export default "__VITE_ASSET__C_tFFmQF__"